module.exports = __webpack_public_path__ + "static/media/19ESCAP24.a2833af0.jpg";